module.exports = __webpack_public_path__ + "static/media/Corn9R4.7b7d6077.png";